import React from 'react';
import {
  Avatar,
  Card,
  Col,
  Typography,
  Row,
  Space,
  Tooltip,
} from 'antd';
import Linkify from '@guuru/react-linkify';
import { MarkdownRender } from '@guuru/react-markdown-render';
import { localize } from '@guuru/translation-common';
import { ResultOf } from '@guuru/graphql-common/gql';
import ListItem from '../../../ListItem';
import DateTime from '../../../DateTime';
import NewsReactions from '../Reactions/NewsReactions';
import GET_PARTNER_NEWS from '../queries/GetExpertPartnersNews';

const { Text } = Typography;

type NewsNode = NonNullable<ResultOf<typeof GET_PARTNER_NEWS>['expert']>['news']['edges'][number]['node'];

interface NewsItemProps {
  item: NewsNode;
  locale?: string;
}

const NewsItem = function ({ item, locale = 'en' }: NewsItemProps) {
  const {
    id,
    partner: {
      id: partnerId,
      name: partnerName,
      settings,
    },
    title,
    updatedAt,
    message,
    reactions,
  } = item;

  const chatWidgetPhotoUrl = settings?.appearance?.chatWidgetPhotoUrl;

  return (
    <ListItem>
      <Card>
        <Space direction="vertical" size="small">
          <Space size="small">
            <Col flex="none">
              <Tooltip title={localize(partnerName, locale)}>
                <Avatar
                  src={chatWidgetPhotoUrl}
                  alt={localize(partnerName, locale)}
                />
              </Tooltip>
            </Col>
            <Col flex="auto">
              <Row>
                <Text strong>
                  <Linkify text={localize(title, locale)} />
                </Text>
              </Row>
              <DateTime
                date={updatedAt}
                options={{ month: 'long', year: 'numeric', day: 'numeric' }}
              />
            </Col>
          </Space>
          <Row style={{ textAlign: 'justify' }}>
            <MarkdownRender content={localize(message, locale)!} />
          </Row>
          <NewsReactions
            partnerId={partnerId}
            newsId={id}
            reactions={reactions}
          />
        </Space>
      </Card>
    </ListItem>
  );
};

export default NewsItem;
